import React,{ useRef } from 'react';
import axios from 'axios'
import { Tooltip,Popover,Result,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined,PlusCircleFilled, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { DeleteOutlined,SearchOutlined,CameraOutlined,PlusOutlined,EditOutlined,PlusSquareFilled,SaveOutlined,LoadingOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import {
  Col,
  Row,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';
import { ToWords } from 'to-words';
import { array } from 'prop-types';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const toWords = new ToWords();

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});


var token= ''
var sacco= ''
var username=''



class LoanConsolidationForm extends React.Component {

  state = {
    datasubmittedsuccessfully:false,
    datarequested:true,
    members:[],
    selectedaccount:'',
    availableloans:[],
    loans_tojoin:[],
    loantypes:[],
    date:'',
    approved_period:0,
    loan_type:''

  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   
   }else{
      sacco= ''
      username=''
   }
   
   if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })
    })

    axios.get(serverconfig.backendserverurl+`/api/loantypes/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          loantypes:res.data
        })

        this.setState({datarequested:false})

    })


  }


  //consolidation new total
  newconsolidation_Total=()=>{
    var total=0

    this.state.loans_tojoin.map((item)=>{
      total+=Number(item.balancetotalprinciple)
      total+=Number(item.balancetotalinterest)

    })

    return total;

  }

    //chekc if invoice exists
    isLoanAdded=(loan_number, inv_list) => {
      return inv_list.some((item) => item.loan_number === loan_number);
    };


  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {

    const columns = [
      {
        title: "Add To List",
        dataIndex: "loan_number",
        key: "id",
        render: (text,record) =>
        <p>
          <PlusCircleFilled 
          style={{color:this.isLoanAdded(record.loan_number,this.state.loans_tojoin)===true?"green":'grey',
          fontSize: '30px'
          ,margin:2}}
          
          onClick={()=>{
            if (this.isLoanAdded(record.loan_number,this.state.loans_tojoin)===true){
             
              this.setState({ loans_tojoin:  [...this.state.loans_tojoin.filter(todo => todo.loan_number
                !==record.loan_number)]});
            
              console.log("Invoice removed")
          
            }else{
              this.setState({loans_tojoin: [...this.state.loans_tojoin,record  ]});
              console.log("Invoice added")
            }


          }}
                    
          />
        </p>
      },
      
      {
        title: "Date of issuance",
        dataIndex: "date",
        key: "id",
      },
     
      {
        title: "Loan Amount",
        dataIndex: "approved_amount",
        key: "id",
        render: (text) => (
          <CurrencyFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
          />
        ),
      },

      {
        title: "Principle Paid",
        dataIndex: "paidtotalprinciple",
        key: "id",
        render: (text) => (
          <CurrencyFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
          />
        ),
      },


      {
        title: "Interest Paid",
        dataIndex: "paidtotalinterest",
        key: "id",
        render: (text) => (
          <CurrencyFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
          />
        ),
      },


      {
        title: "Principle Balance",
        dataIndex: "balancetotalprinciple",
        key: "id",
        render: (text) => (
          <CurrencyFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
          />
        ),
      },

      {
        title: "Interest Balance",
        dataIndex: "balancetotalinterest",
        key: "id",
        render: (text) => (
          <CurrencyFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
          />
        ),
      },



    ];



    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      if(this.state.datasubmittedsuccessfully===true){
        return(
          <div>

            <Row >
                  <Col xs="12" sm="6" lg="6">
                    <Card>
                    <Result
                    status="success"
                    title="Successful loan consolidation "
                    subTitle="Please finish off transaction"
                    extra={[
                      <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
                     
                    ]}
                    />

                    </Card>
                 </Col>
            </Row>
          </div>)
      }else{
        return(
          <div>

          <FormItem label="Member">
                <Select 
                placeholder="Account No | Name" 
                value={this.state.selectedaccount}
                onChange={(val)=>{
                  
                  this.setState({selectedaccount:val})
                
                    //GET ALL ISSUED LOANS
                  axios.get(`${serverconfig.backendserverurl}/customqueries/get_memberactive_loans/${val}`)
                  .then(res => {  
                      this.setState({availableloans: JSON.parse(res.data.report) })
                  })
                
                
                }} 
                showSearch
                optionFilterProp="children"
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onSearch={this.onSearch}
                                      
                >
                  {this.state.members.map(
                    (accnt)=>(
                      <Option value={accnt.id}>{accnt.AccountNumber} | {accnt.FullName}</Option>
                    ))}
                </Select>
            </FormItem>


            {
              this.state.availableloans.length>0?
              <div>
               <h4>Add loans to consolidation list (Select)  </h4>

                <Table
                columns={columns}
                pagination={{ showQuickJumper: true, showSizeChanger: true }}
                dataSource={this.state.availableloans}
                scroll={{ x: 1000 }}
                bordered
                size='small'
                />
                </div>
            :
            null
            }


            <h3>New Loan total:
               <CurrencyFormat
                  value={this.newconsolidation_Total()}
                  displayType={"text"}
                  thousandSeparator={true}
                />
            </h3>


            <FormItem label="New Loan Type">
              <Select 
              placeholder="Loan Type" 
              style={{ }} 
              value={this.state.loan_type} 
              onChange={(val)=>{this.setState({loan_type:val})}} 
              showSearch
              optionFilterProp="children"
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onSearch={this.onSearch}
              >
                {this.state.loantypes.map(
                  (stf)=>(
                    <Option value={stf.id}>{stf.loan_type_name}</Option>
                  ))}
              </Select>
          </FormItem>


            <FormItem label="New Loan date">
                <DatePicker 
                 onChange={(date, dateString) => this.setState({ date: dateString})} format={dateFormat} />
            </FormItem>


            <FormItem label={'Approved Period (Months/Weeks/Days)'} >       
                <Input name="approved_period" 
                type='number'  
                placeholder="Approved period." 
                value={this.state.approved_period}
                 onChange={(val)=>{this.setState({approved_period:val.target.value})}} />
            </FormItem>


            <Button 
              type='primary'
              onClick={()=>{ 
                if (this.state.loans_tojoin.length<=0){
                  message.error("Please select loans")
                }else if (this.newconsolidation_Total()<=0){
                  message.error("New loan amount zero")
                }else{
                  this.setState({datarequested:true})

                let form_data = new FormData();
                form_data.append('loan_type', this.state.loan_type);
                form_data.append('approved_amount', this.newconsolidation_Total());
                form_data.append('date', this.state.date);
                form_data.append('approved_period', this.state.approved_period);
                form_data.append('loans_tojoin',JSON.stringify(this.state.loans_tojoin)  );
                form_data.append('sacco', sacco);
                form_data.append('username', username);
                form_data.append('selectedaccount', this.state.selectedaccount);

                axios.post(serverconfig.backendserverurl+'/customqueries/createloanconsolidation', form_data, {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                  })
                .then(res => {
                    message.info(res.data.message)
                    this.setState({datarequested:false})
                    this.setState({datasubmittedsuccessfully:true})
                })
                .catch(error => console.log(error))

                }

                

              }}>
                  Create New Loan
            </Button>

  
          </div>               
        )
      }

    }
   
  }
}

export default LoanConsolidationForm; 
